import * as api from "../../constants/api";
import * as axiosUtils from "../../utils/axiosUtils";
import { toIsoString } from "../../utils/date";

export const actionTypeAArsrapport = "AARSRAPPORT";

export const getAArsrapport = (params) => {
  return axiosUtils.GetAllWithParamsSerializer(
    api.GET_AARSRAPPORT_URL,
    {
      fraDato: toIsoString(params.fraDato),
      tilDato: toIsoString(params.tilDato),
      ileggelsestypeIds: params.ileggelsestypeIds,
    },
    actionTypeAArsrapport,
  );
};
